// extracted by mini-css-extract-plugin
export default {"container":"UserChange_container__HNltb","userChangeContainer":"UserChange_userChangeContainer__gTDgT","buttonWrapper":"UserChange_buttonWrapper__OrkVr"};